export const GRADIENT_COLOR_MIXED =
  'linear-gradient(135deg, #40e0d0 0%, #ff8c00 50%, #ff0080 100%)';

// export const GRADIENT_COLOR_MIXED =
//   'linear-gradient(135deg, rgba(255,0,0,1) 0%, rgba(109,167,255,1) 25%, rgba(73,255,54,1) 50%, rgba(170,0,162,1) 75%, rgba(255,0,0,1) 100%)';
